import { Outlet } from 'react-router-dom';
import { JSX } from 'react';

import { Header } from '../../../common/header';
import { Footer } from '../../../common/footer';
import { useStyles } from './layout-primary.styles';

export const LayoutPrimary = (): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Header />
      <main className={classes.main} data-testid="main-landmark">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
